angular.module('login.social.google', ['security.service']);
angular.module('login.social.google').config(['$routeProvider', function($routeProvider){
  $routeProvider
    .when('/login/google/callback', {
      resolve: {
        verify: ['$log', '$q', '$location', '$route', 'security', function($log, $q, $location, $route, security){
          var redirectUrl;
          var params = $route.current.params;
          var promise = security.socialLogin('google', params)
            .then(function(data){
              if(data.success) {
                // redirectUrl = data.defaultReturnUrl || '/account'
                redirectUrl = '/account';
              }
              return $q.reject();
            })
            .catch(function(){
              redirectUrl = redirectUrl || '/login';
              $location.search({}); //remove search params added by passport/google
              $location.path(redirectUrl);
              return $q.reject();
            });
          return promise;
        }]
      },
      reloadOnSearch: false
    })
  ;
}]);



// WEBPACK FOOTER //
// ./client/src/app/login/social/login-google.js